import { render, staticRenderFns } from "./TableTicket.vue?vue&type=template&id=0f12239e&scoped=true&"
import script from "./TableTicket.vue?vue&type=script&lang=js&"
export * from "./TableTicket.vue?vue&type=script&lang=js&"
import style0 from "./TableTicket.vue?vue&type=style&index=0&id=0f12239e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12239e",
  null
  
)

export default component.exports